export default __webpack_public_path__ + "static/media/reviews_icon2.27fc363b.svg";